/**
 * Resizing class
 * @since 2019-02-28
 * @desc เมื่อ window มีการ resize จะทำการใส่คลาส resizing และจะลบคลาสออกเองหลังจากหยุดปรับขนาดของ window เป็นเวลา 250 ms
 */
var timer;
window.addEventListener('resize', function () {
    document.body.classList.add('resizing');
    clearTimeout(timer);
    timer = setTimeout(function () {
        document.body.classList.remove('resizing');
    }, 250);
}.throttle(16));
